const dataTableMixin = {
	data() {
		return {
			options: {
				itemsPerPage: 0,
				page: 1
			},

			defaultOptions: {
				page: 1,
				itemsPerPage: 0,
				sortBy: [],
				sortDesc: [],
			},

			initialOptions: null
		}
	},

	computed: {
		serverItemsLength() {
			if (!this.schema?.serverSidePaginate) {
				return -1
			}

			const rowsToFirstRequest = this.itemsPerPage ?? this.itemsPerPageOptions[0].value;
			if (!this.items?.length) {
				return (!isNaN(parseFloat(rowsToFirstRequest)) && isFinite(rowsToFirstRequest)) ? parseInt(rowsToFirstRequest, 10) : rowsToFirstRequest;
			}

			const totalRows = (this.items[0]?.total_rows || this.items[0]?.totalRows)
			if (this.items.length && totalRows) {
				return (!isNaN(parseFloat(totalRows)) && isFinite(totalRows)) ? parseInt(totalRows, 10) : totalRows;
			}

			return -1;
		},
	},

	methods: {
		fetchItems(params = {}) {
			const { resetOptions, prevPage } = params;

			if (resetOptions) {
				this.expanded = []

				if (prevPage === this.page) {
					// se for a mesma página basta aplicar as opções iniciais novamente
					this.options = structuredClone(this.initialOptions)
				} else {
					// se não for a mesma page é necessário iniciar o options novamente
					this.options = structuredClone({
						...this.defaultOptions,
						itemsPerPage: this.setItemsPerPage(),
					})

					if (this.keyTargetSelect) {
						this.selected = this.items.filter( i => i[this.keyTargetSelect] );
					}

					this.initialOptions = structuredClone(this.options)
				}

				// Após resetar as opções o fecthItems já é chamado pelo watch, por isso o return
				return
			}

			const { itemsPerPage, sortBy, sortDesc } = this.options;
			const pageNumber = this.options.page;
			const offset = (pageNumber - 1) * itemsPerPage;

			const filter = (this.$store.getters['page/pageFilter'](this.page) || {});

			if (this.options.multiSort) {
				Object.assign(filter, {
					limit: itemsPerPage,
					offset: offset,
					sortBy: sortBy != undefined && sortBy.length > 0 ? sortBy : null,
					sortDesc: sortBy != undefined && sortBy.length > 0 ? sortDesc : null
				});
			} else {
				Object.assign(filter, {
					limit: itemsPerPage,
					offset: offset,
					sortBy: sortBy[0],
					sortDesc: sortDesc[0]
				});
			}

      // Determina se schema.recordActionsModel.targetList é uma string igual a "dialog"
			let reOrder = false;
			const targetList = this.schema?.targetList;
			if (typeof targetList === 'string' && targetList === 'dialog') {
				reOrder = params && typeof params.reOrder === 'boolean' ? params.reOrder : false;
			}



			this.$store.dispatch('page/loadDataValues', {
				page: this.page,
				mode: this.mode,
				filter: filter,
        reOrder: reOrder
			});
		},

		setItemsPerPage() {
      return 'itemsPerPage' in this.attributesTable.dataTable
        ? this.attributesTable.dataTable.itemsPerPage
        : this.itemsPerPageOptions[0].value;
		}
	},

	watch: {
		options(curr, prev) {
			// ao carregar a pagina os dados já foram carregados pelo loadPage
			// ou se nao for paginação do lado do servidor os dados não devem ser carregados novamente
			if (prev === undefined || this.serverItemsLength === -1 || !this.schema?.serverSidePaginate) return;

			this.expanded = []

			const watchProps = ['page', 'itemsPerPage', 'sortBy', 'sortDesc'];

			for (let i = 0; i < watchProps.length; i++) {
				const key = watchProps[i];

				if (prev[key] !== curr[key]) {
					const isSort = key === 'sortBy' || key === 'sortDesc';
					const isDialog = this.$options?.propsData?.schema?.targetList === 'dialog';
					const reOrder = isSort || isDialog;
					return this.fetchItems(reOrder ? { reOrder: true } : undefined);
				}
			}
		},

		// redefinindo pagina inicial quando a quantidade total de items do servidor for alterado
		// ajustando o componente de paginação quando for realizada uma pesquisa pelo modo search
		serverItemsLength(curr, prev) {
			if (curr !== prev) {
				this.options.page = 1;
			}
		}
	}
}

export default dataTableMixin;
